import gql from 'graphql-tag'

export const GET_GEOFENCES = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      isSuccessful
      message
      geofences {
        data {
          geofenceId
          companyId
          fenceName
          type
          polyData
          circData
          address
          addressDetail
          province
          city
          postalCode
          category
          contactName
          phoneNo
          isGarage
          isServiceLoc
          serviceLocType
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_GEOFENCES_FILTER = gql`
  query GeofencesFilter($filter: GetGeofencesPaginatedFilter) {
    geofencesFilter(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      geofencesFilterPaginated {
        data {
          geofenceId
          fenceName
          category
          city
          address
          province
          polyData
          circData
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        ids
      }
    }
  }
`

export const GET_GEOFENCES_FILTER_ALL = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      isSuccessful
      message
      geofences {
        data {
          geofenceId
          fenceName
        }
      }
    }
  }
`
